import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ContentToolsProps } from '../src/ContentToolsProps.ts';

export const ContentTools: LoadableType<ContentToolsProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContentTools" */ '../src/ContentTools.tsx'))
			.ContentTools,
});
